import { BillingPlanFeatureType } from './constants';
import { useBillingEnabledFeatures } from './useBillingEnabledFeatures';

export function useEnabledFeature(feature: BillingPlanFeatureType): boolean {
  const { data: enabledFeatures } = useBillingEnabledFeatures();

  return !!enabledFeatures?.includes(feature);
}
